import {inject, Injectable} from '@angular/core';
import {TenantService} from './tenant.service';
// TrackJS disabled - removed from dependencies to fix jQuery vulnerability
// import {TrackJS} from 'trackjs';
import { Store} from '@ngrx/store';
import {AppState} from '../store';

export enum ErrorGroups {
  AUTH_ERRORS = 'Authentication Errors',
  NETWORK_ERRORS = 'Network Issues',
  API_ERRORS = 'API Call Failures',
  INSUFFICIENT_PERMISSIONS = 'Insufficient Permissions',
  GENERAL_ERRORS = 'General Errors'
}

export const errorTypes = {
  authErrors: [
    'auth/user-not-found',
    'auth/wrong-password',
    'auth/email-already-in-use',
    'auth/popup-blocked',
    'auth/popup-closed-by-user',
    'auth/network-request-failed'
  ],
  networkErrors: [
    'network-request-failed',
    'Network Error',
    'NetworkError',
    'Network',
    'Failed to fetch',
    'Request Timeout'
  ],
  apiErrors: [
    'api'
  ],
  insufficientPermissions: [
    'Missing or insufficient permissions'
  ]
}


@Injectable({
  providedIn: 'root'
})
export class TrackJsService {

  tenantService = inject(TenantService);

  store = inject(Store<AppState>);



constructor() {
  // TrackJS disabled - removed from dependencies to fix jQuery vulnerability
  console.log('### TrackJsService constructor - TrackJS is disabled');
    // if (environment?.trackJS) {
    //   TrackJS.install(environment.trackJS);
    //   TrackJS.addMetadata('tenantId', this.tenantService.id);
    //   this.store.pipe(
    //     select(selectUser)
    //   ).subscribe(user => {
    //       if (user?.id !== ANONYMOUS_USER.id) {
    //         TrackJS.configure({
    //           userId: user.id
    //         });
    //       }
    //     });
    // }
  }


  logError(error: any, actualError?: any): void {
    // TrackJS disabled - just log to console instead
    error = `${error},  ${actualError}`;
    if (typeof error === 'string' && error.includes('Upload cancelled by user')) {
      console.log('User cancelled upload');
      return;
    }

    console.error('Error logged:', error);
    
    // if (typeof TrackJS !== 'undefined') {
    //   console.log('Logging error to TrackJS', error);
    //   categorizeError(error);
    //   TrackJS.track(error);
    // }
    // else {
    //   console.error('TrackJS is not defined, not tracking error.');
    // }
  }
}

export function categorizeError(error: any): void {
  // TrackJS disabled - function kept for compatibility but does nothing
  // let errorCategory = ErrorGroups.GENERAL_ERRORS;

  // if (typeof error === 'string') {
  //   if (errorTypes.apiErrors.some(apiError => error.includes(apiError))) {
  //     errorCategory = ErrorGroups.API_ERRORS;
  //   } else if (errorTypes.authErrors.some(authError => authError.includes(error) || error.includes(authError))) {
  //     errorCategory = ErrorGroups.AUTH_ERRORS;
  //   } else if (errorTypes.networkErrors.some(networkError => networkError.includes(error) || error.includes(networkError))) {
  //     errorCategory = ErrorGroups.NETWORK_ERRORS;
  //   } else if (errorTypes.insufficientPermissions.some(permissionError => permissionError.includes(error) || error.includes(permissionError))) {
  //     errorCategory = ErrorGroups.INSUFFICIENT_PERMISSIONS;
  //   }
  // }

  // TrackJS.addMetadata('errorGroup', errorCategory);
}
